<ng-container *ngIf="(data || hubbleData); then pdf else nopdf"></ng-container>
<ng-template #pdf>
  <router-outlet></router-outlet>
</ng-template>
<ng-template #nopdf>
  <div class="brand-logo">
    <img [src]="cdnURL + '/partner_assets/lg/electrum-logo.svg'">
  </div>
</ng-template>
